import { render, staticRenderFns } from "./DesconocimientoConsumoDebito.vue?vue&type=template&id=0be6be92"
import script from "./DesconocimientoConsumoDebito.vue?vue&type=script&lang=js"
export * from "./DesconocimientoConsumoDebito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports